export default __webpack_public_path__ + "static/media/icon_caution.1c57d0cd.svg";